import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Home, Building2, Snowflake, Wind } from 'lucide-react';
export function ServiceSelector() {
  const services = [{
    icon: Wind,
    title: 'Ducted Systems',
    desc: 'Whole-home reverse cycle. Quiet, zoned, controlled from your phone.',
    price: 'From A$10,000',
    slug: '/ducted-air-conditioning/',
    featured: true
  }, {
    icon: Home,
    title: 'Split Systems',
    desc: 'One room or multiple. Fast install, big efficiency gains.',
    price: 'From A$2,500',
    slug: '/split-systems-perth/'
  }, {
    icon: Snowflake,
    title: 'Reverse Cycle',
    desc: 'Heating and cooling combined. The Perth standard.',
    price: 'From A$2,500',
    slug: '/reverse-cycle-air-conditioning-perth/'
  }, {
    icon: Building2,
    title: 'Commercial',
    desc: 'Offices, retail, warehouses. Sized correctly the first time.',
    price: 'From A$5,000',
    slug: '/commercial-air-conditioning-installation-in-perth/'
  }];
  return <section className="bg-cream py-20 md:py-28 scroll-mt-24" data-id="element-675">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-676">
        <div className="max-w-3xl mb-12" data-id="element-677">
          <div className="kicker mb-3" data-id="element-678">Where to start</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-679">
            Which service do you need?
          </h2>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl" data-id="element-680">
            Pick the path that fits your home. Not sure? Choose any. Mike works
            it out on the free quote visit.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-681">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <motion.a key={i} href={service.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.08
          }} className={`group lift-card relative flex flex-col rounded-2xl p-7 bg-white border ${service.featured ? 'border-brand shadow-lg shadow-brand/10' : 'border-stone-200'}`} data-id="element-682">
                {service.featured && <span className="absolute -top-2 right-5 px-2.5 h-5 inline-flex items-center bg-accent text-ink-900 text-[10px] uppercase tracking-wider font-bold rounded-full" data-id="element-683">
                    Most popular
                  </span>}
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${service.featured ? 'bg-brand text-white' : 'bg-brand-soft text-brand'}`} data-id="element-684">
                  <Icon size={22} strokeWidth={2} data-id="element-685" />
                </div>
                <h3 className="font-display text-xl font-extrabold text-ink-900 tracking-tight mb-2" data-id="element-686">
                  {service.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed mb-5 flex-grow" data-id="element-687">
                  {service.desc}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-stone-200" data-id="element-688">
                  <span className="text-sm font-bold text-ink-900 tabular-nums" data-id="element-689">
                    {service.price}
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-semibold text-brand group-hover:gap-2 transition-all" data-id="element-690">
                    Explore
                    <ArrowRight size={14} strokeWidth={2.5} data-id="element-691" />
                  </span>
                </div>
              </motion.a>;
        })}
        </div>
      </div>
    </section>;
}